define('instrumentation/log-category', {
  PERFORMANCE: 'ClientPerf',
  ERROR: 'ApplicationErrorClientScript',
  TRACE: 'ClientTrace',
  CLICKEVENT: 'ClickEvent',
  INPUTCHANGEEVENT: 'InputChangeEvent',
  KEYBOARDEVENT: 'KeyboardEvent',
  ROUTECHANGEEVENT: 'RouteChangeEvent',
});
